export default __webpack_public_path__ + "static/aws-data-lake-event-management-solutions-da609569bf686027e1cc2d3549752e73.jpg";